import { render, staticRenderFns } from "./ssoEncrypt.vue?vue&type=template&id=60829e40"
import script from "./ssoEncrypt.vue?vue&type=script&lang=js"
export * from "./ssoEncrypt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60829e40')) {
      api.createRecord('60829e40', component.options)
    } else {
      api.reload('60829e40', component.options)
    }
    module.hot.accept("./ssoEncrypt.vue?vue&type=template&id=60829e40", function () {
      api.rerender('60829e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/ssoEncrypt.vue"
export default component.exports